<template>
  <div>
    <div class="d-flex align-items-center justify-content-between mb-4">
      <div>
        <div class="text-muted small text-uppercase font-weight-bold">CMS</div>
        <h2 class="h4 font-weight-bold text-primary mb-0">Quản lý banner</h2>
      </div>
      <b-button variant="primary" pill @click="openCreateModal">Tạo banner</b-button>
    </div>

    <div class="admin-card bg-white p-4">
      <b-table :items="banners" :fields="fields" responsive>
        <template #cell(image)="row">
          <img :src="resolveAssetUrl(row.item.image)" alt="Banner" class="rounded" style="width: 120px; height: 60px; object-fit: cover;">
        </template>
        <template #cell(status)="row">
          <b-badge :variant="row.item.status ? 'success' : 'secondary'">
            {{ row.item.status ? "Hiển thị" : "Ẩn" }}
          </b-badge>
        </template>
        <template #cell(actions)="row">
          <div class="d-flex">
            <b-button size="sm" variant="outline-primary" class="mr-2" @click="openEditModal(row.item)">Sửa</b-button>
            <b-button size="sm" variant="outline-danger" @click="removeBanner(row.item)">Xóa</b-button>
          </div>
        </template>
      </b-table>
    </div>

    <b-modal v-model="showModal" size="lg" title="Banner" hide-footer>
      <b-form @submit.prevent="saveBanner">
        <b-form-group label="Tiêu đề">
          <b-form-input v-model.trim="form.title" required />
        </b-form-group>
        <b-form-group label="Mô tả">
          <b-form-textarea v-model.trim="form.description" rows="3" />
        </b-form-group>
        <b-form-group label="Ảnh">
          <image-uploader v-model="form.image" />
        </b-form-group>
        <div class="row">
          <div class="col-md-6">
            <b-form-group label="Nút CTA">
              <b-form-input v-model.trim="form.buttonText" />
            </b-form-group>
          </div>
          <div class="col-md-6">
            <b-form-group label="Liên kết">
              <b-form-input v-model.trim="form.buttonLink" />
            </b-form-group>
          </div>
        </div>
        <b-form-group label="Thứ tự hiển thị">
          <b-form-input v-model.number="form.displayOrder" type="number" min="1" />
        </b-form-group>
        <b-form-checkbox v-model="form.status" switch class="mb-4">Hiển thị</b-form-checkbox>
        <div class="d-flex justify-content-end">
          <b-button variant="outline-secondary" class="mr-2" @click="showModal = false">Hủy</b-button>
          <b-button type="submit" variant="primary">{{ editingId ? "Cập nhật" : "Tạo mới" }}</b-button>
        </div>
      </b-form>
    </b-modal>
  </div>
</template>

<script>
import {
  fetchAdminBanners,
  createBanner,
  updateBanner,
  deleteBanner
} from "../../api/admin";
import ImageUploader from "../../components/ImageUploader.vue";
import { isUnauthorizedError } from "../../utils/apiErrors";
import { resolveAssetUrl } from "../../utils/asset";

function defaultForm() {
  return {
    title: "",
    description: "",
    image: "",
    buttonText: "",
    buttonLink: "",
    displayOrder: 1,
    status: true
  };
}

export default {
  name: "AdminBannersView",
  components: {
    ImageUploader
  },
  data: function data() {
    return {
      showModal: false,
      editingId: "",
      banners: [],
      form: defaultForm(),
      fields: [
        { key: "image", label: "Ảnh" },
        { key: "title", label: "Tiêu đề" },
        { key: "status", label: "Trạng thái" },
        { key: "displayOrder", label: "Thứ tự" },
        { key: "actions", label: "Thao tác" }
      ]
    };
  },
  created: function created() {
    this.loadBanners();
  },
  methods: {
    resolveAssetUrl,
    async loadBanners() {
      try {
        const response = await fetchAdminBanners();
        this.banners = response.data;
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    },
    openCreateModal() {
      this.editingId = "";
      this.form = defaultForm();
      this.showModal = true;
    },
    openEditModal(banner) {
      this.editingId = banner._id;
      this.form = {
        title: banner.title,
        description: banner.description,
        image: banner.image,
        buttonText: banner.buttonText,
        buttonLink: banner.buttonLink,
        displayOrder: banner.displayOrder,
        status: banner.status
      };
      this.showModal = true;
    },
    async saveBanner() {
      try {
        if (this.editingId) {
          await updateBanner(this.editingId, this.form);
          this.$bvToast.toast("Cập nhật banner thành công.", { variant: "success", solid: true });
        } else {
          await createBanner(this.form);
          this.$bvToast.toast("Tạo banner thành công.", { variant: "success", solid: true });
        }

        this.showModal = false;
        this.form = defaultForm();
        this.loadBanners();
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    },
    async removeBanner(banner) {
      try {
        await deleteBanner(banner._id);
        this.$bvToast.toast("Đã xóa banner.", { variant: "success", solid: true });
        this.loadBanners();
      } catch (error) {
        if (isUnauthorizedError(error)) return;
        throw error;
      }
    }
  }
};
</script>

